// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { postOnlineCourseFeedback } from '../../apis/course';
import { OnlineCourseFeedbackResponse } from '../../types/OnlineCourseFeedback';
import { postOnlineCourseFeedbackActions } from '../actionCreators/postOnlineCourseFeedbackActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: postOnlineCourseFeedbackActions.success,
  failure: postOnlineCourseFeedbackActions.failure
};

type RequestActionTypes = ActionType<
  typeof postOnlineCourseFeedbackActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const postOnlineCourseFeedbackEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(postOnlineCourseFeedbackActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, success, ...others } = action.payload;
      // send api promise
      return postOnlineCourseFeedback(id, others)
        .then((response: OnlineCourseFeedbackResponse) => {
          success && success();

          // handle success case here
          return postOnlineCourseFeedbackActions.success();
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return postOnlineCourseFeedbackActions.failure({ error });
        });
    })
  );
};
